export default __webpack_public_path__ + "static/media/herothree.a7694552.png";